import React, { useEffect, useState } from 'react';

import { RepeaterWrapper } from './BannerNextEvents.style';
import { ContentWrapper } from '../../../styles/shared';
import { CardEventData } from '../../../components/cards/card-event-mobile/CardEventMobile';
import Repeater from '../../../components/repeater/Repeater';
import { Event } from '../../../models/auto-generated-strapi-types/types/Event';
import { normalizeAttributesNewsEvents } from '../../../utils/event';
import { getEvents } from '../../../utils/api';
import { GlobalResponse, Slug } from '../../../models/domain/interfaces';
import { stringToISODate } from 'corporate-utils';
import CardEvent from '../../../components/cards/card-event/CardEvent';
import { EventCardType } from '../../../models/enum';
import { fromHumanNumberOfColumnsToRepeaterNumberOfColumns } from '../../../utils/carousels';
import { useWindowSize } from 'usehooks-ts';
import { useTheme } from '@mui/material';
import { MainTitle } from './BannerNextEvents.style';

interface SliderNextEventsProps {
  title: string;
  events: Event[];
}

const INITIAL_ITEM_COUNT = 3;

const BannerNextEvents: React.FC<any> = ({
  data,
  translations,
  isPrerenderRequest,
}: {
  data: SliderNextEventsProps;
  translations: any;
  isPrerenderRequest: boolean;
}) => {
  const { title, events } = data ?? {};

  const { width } = useWindowSize();
  const theme = useTheme();

  const [columns, setColumns] = useState<number>(INITIAL_ITEM_COUNT);

  useEffect(() => {
    switch (true) {
      case width < theme.breakpointsMediaQuery.values.md &&
        width >= theme.breakpointsMediaQuery.values.sm:
        if (columns !== 2) {
          setColumns(2);
        }
        break;
      case width >= theme.breakpointsMediaQuery.values.md:
      case width < theme.breakpointsMediaQuery.values.sm &&
        width >= theme.breakpointsMediaQuery.values.xs:
      default:
        if (columns !== 3) {
          setColumns(3);
        }
        break;
    }
  }, [columns, theme.breakpointsMediaQuery.values, width]);

  const mappedEvents = events?.map<CardEventData>((event) => ({
    id: event?.id,
    title: event?.attributes?.title,
    image:
      event?.attributes?.thumbnailForEventList?.data ||
      event?.attributes?.thumbnail?.data,
    fair: event?.attributes?.fair,
    location: event?.attributes?.location,
    startDate: (event?.attributes as any)?.startDate,
    endDate: (event?.attributes as any)?.endDate,
    stand: event?.attributes?.stand,
    slug: event?.attributes?.slug || '',
    labelNation: event?.attributes?.labelNation || '',
    labelParticipation: event?.attributes?.labelParticipation || '',
    logoNation: event?.attributes?.logoNation || undefined,
    logoPartecipation: event?.attributes?.logoPartecipation || undefined,
    types: event?.attributes?.types?.data,
    url: (event?.attributes as any)?.url,
    isPrerenderRequest,
  }));

  if (!events?.length) return <></>;
  return (
    <ContentWrapper>
      <MainTitle>{title ?? ''}</MainTitle>
      <RepeaterWrapper>
        <Repeater
          spacing={3}
          cols={{
            md: fromHumanNumberOfColumnsToRepeaterNumberOfColumns(3),
            sm: fromHumanNumberOfColumnsToRepeaterNumberOfColumns(2),
            xs: fromHumanNumberOfColumnsToRepeaterNumberOfColumns(1),
          }}
          props={{
            translations,
            isPrerenderRequest,
            cardType: EventCardType.SMALL,
          }}
          data={mappedEvents.slice(0, columns)}
          component={CardEvent}
        />
      </RepeaterWrapper>
    </ContentWrapper>
  );
};

export const getServerSideProps = async (
  section: any,
  translations: any,
  slugAnalyzed: Slug,
  globalLocale: GlobalResponse
) => {
  const getNewsParams: any = {
    locale: slugAnalyzed.locale,
    datesFormat: translations?.date?.sliderNewsEvents?.format,
  };

  const types = section?.types?.data?.map?.((type: any) => type.id);

  let filters = {};
  if (types && types.length > 0) {
    filters = {
      types: {
        id: {
          $in: types,
        },
      },
    };
    getNewsParams.filters = filters;
  }

  const events = await getEvents(getNewsParams);
  section.events =
    normalizeAttributesNewsEvents(
      events,
      'events',
      translations,
      globalLocale?.attributes?.newsAndEventsMerged || false,
      slugAnalyzed.locale
    ) || [];

  section.events = section.events.sort((a: any, b: any) => {
    const { startDate: startDateA } = a.attributes || {};
    const { startDate: startDateB } = b.attributes || {};

    if (startDateA === startDateB) {
      return 0;
    } else {
      const startDateAParsed = stringToISODate(
        (startDateA as any) ?? '',
        translations?.date?.singleEvent?.format,
        slugAnalyzed?.locale
      ) as string;
      const startDateBParsed = stringToISODate(
        (startDateB as any) ?? '',
        translations?.date?.singleEvent?.format,
        slugAnalyzed?.locale
      ) as string;
      if (
        startDateAParsed &&
        startDateBParsed &&
        new Date(startDateAParsed).getTime() >
          new Date(startDateBParsed).getTime()
      ) {
        return 1;
      } else {
        return -1;
      }
    }
  });
};

export default BannerNextEvents;
